import { Box, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { AnalyticsService } from '@/services';
import {
  selectAppRegion,
  selectSessionUserId,
  updateRegion,
  useAppDispatch,
} from '@/store';
import { Region } from '@/types';

import { RegionSelectDropdown } from './components/RegionSelectDropdown';

export const RegionBanner = () => {
  const dispatch = useAppDispatch();
  const appRegion = useSelector(selectAppRegion);
  const userId = useSelector(selectSessionUserId);
  if (userId) return null;

  const switchRegion = (newRegion: Region) => {
    AnalyticsService.switchRegion({ oldRegion: appRegion, newRegion });
    dispatch(updateRegion({ region: newRegion }));
  };

  return (
    <Box sx={styles.root}>
      <Typography variant="body3" sx={{ color: 'text.contrast' }}>
        Select your region:
      </Typography>
      <RegionSelectDropdown
        selectedRegion={appRegion}
        onSelect={region => {
          switchRegion(region);
        }}
      />
    </Box>
  );
};

const styles = {
  root: {
    bgcolor: 'secondary.main',
    color: 'white',
    height: ({ dimensions }: Theme) => dimensions.navBanner.height,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};
